"use client";

import React, { useEffect, useRef } from 'react';

const milestones = [
  {
    year: '2004',
    title: '公司創立',
    desc: '信悅日用品有限公司在上海正式成立，專注於日用品的採購與分銷業務，開啟品牌發展之路。',
    icon: '🏢'
  },
  {
    year: '2008',
    title: '自建工廠',
    desc: '於上海郊區建立自有生產基地，引進先進生產設備，實現從採購到製造的全鏈條自主掌控。',
    icon: '🏭'
  },
  {
    year: '2013',
    title: '進駐電商平台',
    desc: '正式入駐淘寶、京東等主流電商平台，開設品牌旗艦店，開啟線上零售新篇章，年銷售額突破千萬。',
    icon: '🛒'
  },
  {
    year: '2016',
    title: '批發網絡擴張',
    desc: '全國批發合作夥伴突破200家，覆蓋華東、華南、華北等主要區域，構建穩固的線下分銷體系。',
    icon: '🌐'
  },
  {
    year: '2019',
    title: '品質認證達標',
    desc: '通過ISO 9001國際質量管理體系認證及多項國際安全標準認證，產品品質獲得國際市場認可。',
    icon: '🏅'
  },
  {
    year: '2023',
    title: '全渠道戰略升級',
    desc: '整合線上線下資源，推進全渠道數字化轉型，年服務客戶超10萬家，持續引領行業發展。',
    icon: '🚀'
  }
];

export default function MilestonesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.remove('reveal-hidden');
        });
      },
      { threshold: 0.1 }
    );
    sectionRef?.current?.querySelectorAll('.reveal')?.forEach((el) => {
      el?.classList?.add('reveal-hidden');
      observer?.observe(el);
    });
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 px-6 bg-white">
      <div className="max-w-container mx-auto">
        <div className="text-center mb-16 reveal">
          <p className="text-xs font-semibold tracking-widest uppercase text-accent mb-2">
            OUR JOURNEY · 發展歷程
          </p>
          <h2
            className="font-heading font-bold text-brand-fg"
            style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}
          >
            二十年匠心之路
          </h2>
          <p className="mt-4 text-brand-muted max-w-xl mx-auto text-sm leading-relaxed">
            從上海出發，以品質為本，信悅走過了二十年的穩健成長歷程。
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Center line */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-[#6B5040]/20 -translate-x-1/2" />

          <div className="space-y-10 md:space-y-0">
            {milestones?.map((milestone, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div
                  key={milestone?.year}
                  className={`reveal md:flex md:items-center md:gap-8 ${
                    isLeft ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                  style={{ transitionDelay: `${i * 100}ms` }}
                >
                  {/* Content card */}
                  <div className="md:w-[calc(50%-2.5rem)] w-full">
                    <div
                      className={`group bg-[#FAF7F4] border border-[#6B5040]/10 rounded-2xl p-6 hover:shadow-lg hover:border-[#6B5040]/30 transition-all duration-300 ${
                        isLeft ? 'md:text-right' : 'md:text-left'
                      }`}
                    >
                      <div
                        className={`flex items-center gap-3 mb-3 ${
                          isLeft ? 'md:flex-row-reverse' : ''
                        }`}
                      >
                        <span className="text-2xl">{milestone?.icon}</span>
                        <span
                          className="text-3xl font-heading font-bold"
                          style={{ color: '#6B5040' }}
                        >
                          {milestone?.year}
                        </span>
                      </div>
                      <h3 className="font-heading font-semibold text-brand-fg text-lg mb-2">
                        {milestone?.title}
                      </h3>
                      <p className="text-sm text-brand-muted leading-relaxed">
                        {milestone?.desc}
                      </p>
                    </div>
                  </div>
                  {/* Center dot */}
                  <div className="hidden md:flex w-10 flex-shrink-0 justify-center">
                    <div
                      className="w-4 h-4 rounded-full border-2 border-white shadow-md flex-shrink-0"
                      style={{ backgroundColor: '#6B5040' }}
                    />
                  </div>
                  {/* Spacer for opposite side */}
                  <div className="hidden md:block md:w-[calc(50%-2.5rem)]" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
